import { axiosApi } from '../../../plugins/api';

export const getUserInfo = axiosApi({
  url: '/api/account/user/info',
  method: 'GET',
});

// 获取U校园用户信息
export const checkUserInfo = (params) => {
  // console.log('---params--->', params);
  return axiosApi({
  url: '/api/tla/user/userOpen/userInfo',
  method: 'GET',
})({ params })
};
